import * as S from './styles'
import { useFormContainer } from './useFormContainer'
import { Input, Text } from '@/components'
import { Button } from '@/components/button'
import { useInputValidation } from '@/hooks'
import { validateEmail, validatePhone } from '@/utils/validations'

export type FormContainerProps = {
  title: string
  nameInputLabel: string
  nameInputPlaceholder: string
  emailInputLabel: string
  emailInputPlaceholder: string
  phoneInputLabel: string
  phoneInputPlaceholder: string
  buttonText: string
  buttonTextSuccess: string
  elementVisible: boolean
}

export const FormContainer: React.FC<FormContainerProps> = ({
  title,
  nameInputLabel,
  nameInputPlaceholder,
  emailInputLabel,
  emailInputPlaceholder,
  phoneInputLabel,
  phoneInputPlaceholder,
  buttonText,
  buttonTextSuccess,
  elementVisible,
}) => {
  const { handleErrorMessage, handleBlur, handleFocus, focus, clearFocus } =
    useInputValidation()
  const { submitted, form, onChange, isExistErrors, handleSubmitForm, router } =
    useFormContainer({ handleErrorMessage })

  const isFocused = Object.keys(focus).some((field) => Boolean(field))
  return (
    <S.FormContainer
      id="lp-form-container"
      name="Quero um time nata.house - Landing Page"
      disabled={isExistErrors}
      onSubmit={handleSubmitForm}
      elementVisible={elementVisible}
      className={isFocused ? 'isFocus' : ''}
    >
      <Text size="h4" align="center" color="primary" breakLineOn="<br/>">
        {title}
      </Text>
      <Input
        placeholder={nameInputPlaceholder}
        value={form?.name}
        label={nameInputLabel}
        name="name"
        onChange={(e) => onChange(e)}
        type="text"
        className={`input-form ${focus.name ? 'focus' : ''}`}
        onBlur={() => {
          handleBlur('name')
          clearFocus()
        }}
        error={handleErrorMessage('name', form.name)}
        autoFocus={elementVisible}
        onFocus={(e) => handleFocus(e.target.name)}
      />
      {/* The input below is a honey pot, do not remove */}
      <Input
        id="honey-pot"
        value={form?.lastname}
        placeholder="Sobrenome"
        label="Sobrenome"
        name="lastname"
        onChange={(e) => onChange(e)}
        type="text"
        className="h-input"
      />
      <Input
        placeholder={emailInputPlaceholder}
        value={form?.email}
        label={emailInputLabel}
        name="email"
        onChange={(e) => onChange(e)}
        type="text"
        className={`input-form ${focus.email ? 'focus' : ''}`}
        onBlur={() => {
          handleBlur('email')
          clearFocus()
        }}
        error={handleErrorMessage(
          'email',
          form.email,
          validateEmail,
          'E-mail inválido',
        )}
        onFocus={(e) => handleFocus(e.target.name)}
      />
      <Input
        type="tel"
        label={phoneInputLabel}
        name="phone"
        maxLength={router.locale === 'pt-BR' ? 15 : 17}
        placeholder={phoneInputPlaceholder}
        onChange={(e) => onChange(e)}
        value={form?.phone}
        className={`input-form ${focus.phone ? 'focus' : ''}`}
        onBlur={() => {
          handleBlur('phone')
          clearFocus()
        }}
        error={handleErrorMessage('phone', form.phone, validatePhone)}
        onFocus={(e) => handleFocus(e.target.name)}
      />
      <Button
        className="button-container"
        type="submit"
        disabled={isExistErrors || submitted}
      >
        {submitted ? buttonTextSuccess : buttonText}
      </Button>
    </S.FormContainer>
  )
}
